import { firebaseApp, firebaseDb, uid  } from './index'
import { EMAIL_VERIF_PERIOD, AS } from '../config/account'
import userInfo from '../utils/userInfo'

export const create =  (email, password, agreement, onSuccess, onError) => {
  firebaseApp.auth().createUserWithEmailAndPassword(email, password)
    .then(() => {
      const id = uid()
      const d = new Date()
      const dd = d.getTime() + EMAIL_VERIF_PERIOD
      firebaseDb().ref(`users/${id}/account`).set({
          rd: d.toLocaleString(),
          rdd: dd,
          ra: agreement,
          as: AS.DEMO,
          c: 0,
          cmax: 10,
          exd: '',
          o: false,
          e: email
        })
        .then(() => {
          firebaseDb().ref(`SampleData/data`).once('value')
            .then((snapshot) => {
              if (snapshot.exists()) {
                const projectRef = firebaseDb().ref(`users/${id}/projects`)
                let newProjectRef = projectRef.push()
                const projectId = newProjectRef.key
                let updates = {}
                updates[`users/${id}/projects/${projectId}`] = {
                  name: 'Ukázková akce', c: new Date(Date.now()).toISOString()
                }
                updates[`parcels/${projectId}`] = snapshot.val().parcels
                updates[`owners/${projectId}`] = snapshot.val().owners
                updates[`users/${id}/tags`] = snapshot.val().tagsG
                updates[`tags/${projectId}`] = snapshot.val().tagsA
                firebaseDb().ref().update(updates)
                  .then(() => {
                    let user = firebaseApp.auth().currentUser
                    let ui = userInfo(user)
                    ui.ct = dd
                    ifCallback(onSuccess, ui)
                  })
                  .catch((error) => {
                    ifCallback(onError, error)
                  })
              }
            })
            .catch((error) => {
              ifCallback(onError, error)
            })
        })
        .catch((error) => {
          ifCallback(onError, error)
        })
    })
    .catch((error) => {
      ifCallback(onError, error)
    })
}

export const reload = (onSuccess, onError) => {
  firebaseApp.auth().currentUser.reload()
    .then(() => {
      ifCallback(onSuccess, firebaseApp.auth().currentUser.emailVerified)
    })
    .catch((error) => {
      ifCallback(onError, error)
    })
}

export const updateUserName = (name, onSuccess, onError) => {
  let user = firebaseApp.auth().currentUser
  user.updateProfile({
    displayName: name || user.email.split('@')[0]
  })
  .then(() => {
    ifCallback(onSuccess)
  })
  .catch((error) => {
    ifCallback(onError, error)
  })
}

export const reauthenticate = (email, password, onSuccess, onError) => {
  let user = firebaseApp.auth().currentUser
  const credential = firebaseApp.auth.EmailAuthProvider.credential(email, password)
  user.reauthenticateAndRetrieveDataWithCredential(credential)
    .then(() => {
      ifCallback(onSuccess)
    })
    .catch((error) => {
      ifCallback(onError, error)
    })
}

export const updateEmail = (newEmail, onSuccess, onError) => {
  firebaseApp.auth().currentUser.updateEmail(newEmail)
    .then(() => {
      firebaseDb().ref(`users/${uid()}/account/e`).set(newEmail)
      .then(() => {
        ifCallback(onSuccess)
      })
      .catch((error) => {
        ifCallback(onError, error)
      })
    })
    .catch((error) => {
      ifCallback(onError, error)
    })
}

export const updatePassword = (newPassword, onSuccess, onError) => {
  firebaseApp.auth().currentUser.updatePassword(newPassword)
    .then(() => {
      ifCallback(onSuccess)
    })
    .catch((error) => {
      ifCallback(onError, error)
    })
}

export const login = (email, password, onSuccess, onError) => {
  firebaseApp.auth().signInWithEmailAndPassword(email, password)
    .then(() => {
      let user = firebaseApp.auth().currentUser
      user.ddpLo = 1
      ifCallback(onSuccess, userInfo(user))
    })
    .catch((error) => {
      ifCallback(onError, error)
    })
}

export const getCreationTime = (onSuccess, onError) => {
  firebaseDb().ref(`users/${uid()}/account/rdd`).once('value')
    .then(snapshot => {
      let dd = 0
      if (snapshot.exists()) {
        dd = snapshot.val()
      }
      let user = firebaseApp.auth().currentUser
      let ui = userInfo(user)
      ui.ct = dd
      ifCallback(onSuccess, ui)
    })
    .catch((error) => {
      ifCallback(onError, error)
    })
}

export const sendEmail = (onSuccess, onError) => {
  firebaseApp.auth().currentUser.sendEmailVerification()
    .then(() => {
      ifCallback(onSuccess)
    })
    .catch((error) => {
      ifCallback(onError, error)
    })
}

export const sendResetPasswordEmail = (email, onSuccess, onError) => {
  firebaseApp.auth().sendPasswordResetEmail(email)
    .then(() => {
      ifCallback(onSuccess)
    })
    .catch((error) => {
      ifCallback(onError, error)
    })
}

export const setPersistence = (persistence, onSuccess, onError) => {
  const _persistence = persistence
    ? firebaseApp.auth.Auth.Persistence.LOCAL
    :  firebaseApp.auth.Auth.Persistence.SESSION
  firebaseApp.auth().setPersistence(_persistence)
    .then(() => {
      ifCallback(onSuccess)
    })
    .catch((error) => {
      ifCallback(onError, error)
    })
}

export const logout = (onSuccess, onError) => {
  firebaseApp.auth().signOut()
  .then(() => {
    ifCallback(onSuccess)
  })
  .catch((error) => {
    ifCallback(onError, error)
  })
}

const ifCallback = (callback, arg) => {
  if (callback) {
    if (arg) {
      callback(arg)
    } else {
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/Firebase/auth.js